// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"d0ad266c","873":"bd1659b3"}[chunkId] + ".chunk.js";
};